module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr7-b0fd87e0b5fa124156c6bfc7518f40f2.jpg";